import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-table-edit-option',
  template: '<a *ngIf="hasEditPermission" href="javascript:" style="text-decoration: none !important;" class="text-link" (click)="onEditClick()"><i class="icon icon-edit"></i></a>',
  styleUrls: []
})
export class TableEditOptionComponent implements OnInit {
  @Input() rowData: any;
  @Output() editClick: EventEmitter<any> = new EventEmitter();

  hasEditPermission = true;


  constructor() {
  }

  ngOnInit() {
  }

  onEditClick() {
    this.editClick.emit(this.rowData);
  }

}
